/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum JobType {
    Unknown = 0,
    Delivery = 1,
    Installation = 2,
    ReplacementCover = 3,
    Repair = 4,
    Service = 5,
    Survey = 6,
}
